import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { KhoiPhuc } from "./KhoiPhuc";

export const BtnKhoiPhuc = ({ id, code }) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <a onClick={() => setShow(true)} href={() => false}>
        <PopoversBootrap
          contentText="Khôi phục"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img
            style={{ marginLeft: "5px" }}
            src="/app-assets/images/icon-thu-hoi-v2.png"
            alt="Khôi phục"
          />
        </PopoversBootrap>
      </a>
      {show && (
        <KhoiPhuc show={show} onHide={() => setShow(false)} Id={id} Code={code} />
      )}
    </>
  );
};
